module.exports = __webpack_public_path__ + "img/b-icon_virtual-manager.72c1f304.svg";